module.exports = __webpack_public_path__ + "img/data-security.a14d156a.svg";